import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "layout-wrapper"
}
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = {
  key: 2,
  class: "no-layout"
}

import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import Navbar from '@/components/Navbar.vue'
import Sidebar from '@/components/Sidebar.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const sidebarCollapsed = ref(false)
const sidebarOpen = ref(false)
const windowWidth = ref(window.innerWidth)

const useDefaultLayout = computed(() => {
  if (route.meta) return route.meta.layout !== 'empty'
  if (route.fullPath === '/login') return false
  return true
})

const toggleSidebar = () => {
  if (windowWidth.value < 640) {
    sidebarOpen.value = !sidebarOpen.value
  } else {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }
}

const closeSidebar = () => {
  sidebarOpen.value = false
}

const handleResize = () => {
  windowWidth.value = window.innerWidth
  if (windowWidth.value >= 640) {
    sidebarOpen.value = false
  }
}

// Fechar sidebar ao navegar para outra pagina
watch(() => route.fullPath, () => {
  closeSidebar()
})

onMounted(() => window.addEventListener('resize', handleResize))
onUnmounted(() => window.removeEventListener('resize', handleResize))

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass({ 'sidebar-collapsed': sidebarCollapsed.value, 'sidebar-open': sidebarOpen.value })
  }, [
    (useDefaultLayout.value)
      ? (_openBlock(), _createBlock(Navbar, {
          key: 0,
          onToggleSidebar: toggleSidebar
        }))
      : _createCommentVNode("", true),
    (useDefaultLayout.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (sidebarOpen.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "sidebar-overlay",
                onClick: closeSidebar
              }))
            : _createCommentVNode("", true),
          _createVNode(Sidebar, {
            collapsed: sidebarCollapsed.value,
            open: sidebarOpen.value,
            onClose: closeSidebar
          }, null, 8, ["collapsed", "open"]),
          _createElementVNode("main", _hoisted_2, [
            _createVNode(_component_router_view)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_router_view)
        ]))
  ], 2))
}
}

})